import { render, staticRenderFns } from "./airClean.vue?vue&type=template&id=74770681&scoped=true&"
import script from "./airClean.vue?vue&type=script&lang=js&"
export * from "./airClean.vue?vue&type=script&lang=js&"
import style0 from "./airClean.vue?vue&type=style&index=0&id=74770681&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74770681",
  null
  
)

export default component.exports